export default __webpack_public_path__ + "static/media/Desktop.1f39190e.svg";